<div class="select-territory">
  <p class="select-territory__description">
    Prices and product availability vary by region. Choose your delivery
    territory so we can show you the freshest options and the right
    pricing for your area.
  </p>

  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (hasError()) {
    <div class="select-territory__error animated fadeIn">
      <span class="material-symbols-outlined">error</span>
      <p>We couldn't load the list of territories. Please try again.</p>
      <button type="button" class="btn btn-outline-primary" (click)="fetchTerritories()">Retry</button>
    </div>
  } @else {
    <mat-form-field class="select-territory__field w-75 d-flex mx-auto" appearance="outline">
      <mat-label>Territory</mat-label>
      <mat-select [(ngModel)]="selectedId"
        [disabled]="isLoading() || !territories().length"
        placeholder="Choose your delivery territory">
        @for (territory of territories(); track territory.id) {
          <mat-option [value]="territory.id">{{ territory.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <small class="select-territory__hint">
      <span class="material-symbols-outlined">info</span>
      You can change your territory anytime from the header.
    </small>

    <div class="select-territory__actions">
      <button type="button"
        class="btn btn-primary btn-lg select-territory__cta"
        [disabled]="!selectedId"
        (click)="confirm()">
        Continue
      </button>
    </div>
  }
</div>
